import { render, staticRenderFns } from "./PlayerBarButton.vue?vue&type=template&id=62956001&scoped=true&"
import script from "./PlayerBarButton.vue?vue&type=script&lang=ts&"
export * from "./PlayerBarButton.vue?vue&type=script&lang=ts&"
import style0 from "./PlayerBarButton.vue?vue&type=style&index=0&id=62956001&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62956001",
  null
  
)

export default component.exports